import { Download } from 'lucide-react'
import { useDownloadBackupMutation } from '../hooks/useDownloadBackupMutation'
import { Button } from '@/components/ui/button'

export default function DownloadButton({ fileId }: { fileId: string }) {
  const { mutateAsync: downloadFile, isPending: isDownloading } =
    useDownloadBackupMutation()

  const handleDownload = async () => {
    await downloadFile(fileId)
  }

  return (
    <Button
      size="sm"
      className="inline-flex items-center px-2 py-1 rounded text-xs font-medium hover:bg-blue-100"
      onClick={handleDownload}
      disabled={isDownloading}
    >
      <Download className="mr-1 h-4 w-4" />
      Download
    </Button>
  )
}
